import React from 'react';
import { initSentry } from '@anyroad/sentry';
import { wrapAllComponents } from 'lib/withIntl';

window.React = React;
window.ReactDOM = require('react-dom');

initSentry({ application: 'privacy' });

const Privacy = require('views/privacy/PrivacyRequest').default;

window.Views = wrapAllComponents({
  Privacy,
});
